import type { ComponentProps, ReactNode, RefObject } from "react";
import { ChatPage } from "../pages/ChatPage";
import { Icon } from "../components/Icon";

/** A single mounted conversation follows the Owner across every work page. */
export function OwnerConversationDock({ fullPage, hidden = false, collapsed = false, onCollapse, onExpand, onReturn, returnLabel, containerRef, interactions, ...chat }: ComponentProps<typeof ChatPage> & {
  hidden?: boolean;
  collapsed?: boolean; onCollapse?: () => void;
  fullPage: boolean; onExpand: () => void; onReturn: () => void; returnLabel: string;
  containerRef: RefObject<HTMLElement>; interactions?: ReactNode;
}) {
  return <aside id="owner-conversation" ref={containerRef} hidden={hidden || collapsed} className={`owner-conversation-dock${fullPage ? " is-full-page" : ""}`} role={fullPage ? "main" : "complementary"} aria-label="当前 IP 对话">
    {/* The Agent's name is already on the bar beside this column; this one says what the column is, or the way back. */}
    <div className="owner-conversation-toolbar">
      {fullPage
        ? <button className="btn btn-quiet" type="button" onClick={onReturn}><Icon name="back" size={16} />{returnLabel}</button>
        : <><strong>对话</strong>
          <div className="conversation-tools">
            <button className="btn btn-quiet btn-icon" aria-label="放大对话" title="放大对话" type="button" onClick={onExpand}><Icon name="expand" size={18} /></button>
            <button className="btn btn-quiet" aria-label="收起对话" title="收起对话，把空间留给当前工作" type="button" onClick={onCollapse}><Icon name="collapse" size={18} />收起对话</button>
          </div></>}
    </div>
    <ChatPage {...chat} dock={!fullPage} aboveComposer={interactions} />
  </aside>;
}
